import { render, staticRenderFns } from "./SignInSignUpLayout.vue?vue&type=template&id=240a5132&scoped=true"
import script from "./SignInSignUpLayout.vue?vue&type=script&lang=js"
export * from "./SignInSignUpLayout.vue?vue&type=script&lang=js"
import style0 from "./SignInSignUpLayout.vue?vue&type=style&index=0&id=240a5132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240a5132",
  null
  
)

export default component.exports